$.fn.chToggleAccordion = function () {
    this.on('change', toggle).each(toggle);
    this.parents("form").submit($.proxy(toggle, this[0]));

    function toggle() {
        var body = $(this).parent().parent().find('.collapse').first()
            .collapse(this.checked ? 'show' : 'hide');

        var card = $(body[0]).find('.card-body.card-collapse')[0];

        var fields = body.find('input,select,textarea').filter(function (i, el) {
            return $(el).closest('.card-body.card-collapse')[0] === card;
        });

        var tokenfields = body.find('[data-chrole=token]').filter(function (i, el) {
            return $(el).closest('.card-body.card-collapse')[0] === card;
        });

        var accordionGroup = $(this).closest('.card')[0];
        var disableHiddenFields = accordionGroup.getAttribute("data-disable-hidden-fields") !== 'false';

        if (this.checked) {
            if (disableHiddenFields) {
                fields.removeAttr('disabled');
            }
            
            // HACK use tokenfield update to recalculate widths incase input was hidden when created
            tokenfields.tokenfield('enable').tokenfield('update');

            if(this.type === 'radio') {
                $(this).closest('.accordion').find('[data-chrole="accordion-toggle"]').not(this).each(toggle);

            }
        } else {
            if (disableHiddenFields) {
                fields.attr('disabled', 'disabled');
                tokenfields.tokenfield('disable');
            }
        }
        
    }
};
